import { aud, productTradeInfo, TradeStatus } from "@/lib/util/trade"
import LocalizedClientLink from "@/modules/common/components/localized-client-link"

/** Price block for cards and product pages. Guests/pending see RRP only; approved accounts see trade price, RRP and margin. */
export default function TradePrice({
  product,
  status,
  tier,
  size = "card",
}: {
  product: any
  status: TradeStatus
  tier?: string
  size?: "card" | "page"
}) {
  const info = productTradeInfo(product)
  const big = size === "page"

  if (status === "approved" && info.fromTrade !== null) {
    return (
      <div className="flex flex-col gap-0.5" data-testid="trade-price">
        <div className="flex items-baseline gap-2 flex-wrap">
          <span className={big ? "font-heading text-4xl" : "font-medium text-lg"}>
            {info.multi ? "From " : ""}
            {aud(info.fromTrade)}
          </span>
          <span className="text-xs text-elevate-grey-mid">ex GST</span>
          {tier && tier !== "Standard" && (
            <span className="text-xs uppercase tracking-[0.08em] bg-elevate-sage text-elevate-black px-1.5 py-0.5 rounded">{tier} price</span>
          )}
        </div>
        <div className="flex gap-3 text-xs text-elevate-grey-mid">
          {info.rrp !== null && <span>RRP {aud(info.rrp)}{info.hasGst ? " inc GST" : ""}</span>}
          {info.margin !== null && <span className="text-emerald-800 font-medium">{Math.round(info.margin * 100)}% margin</span>}
          {!info.hasGst && <span>GST-free</span>}
        </div>
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-0.5" data-testid="rrp-price">
      {info.rrp !== null ? (
        <div className="flex items-baseline gap-2">
          <span className={big ? "font-heading text-3xl" : "font-medium text-base"}>RRP {aud(info.rrp)}</span>
          <span className="text-xs text-elevate-grey-mid">{info.hasGst ? "inc GST" : "GST-free"}</span>
        </div>
      ) : (
        <span className={big ? "font-heading text-2xl" : "font-medium text-base"}>Trade product</span>
      )}
      <span className="text-xs text-elevate-grey-mid">
        {status === "pending" ? "Trade price visible once your account is approved" : big ? (
          <>
            <LocalizedClientLink href="/account" className="underline underline-offset-2 hover:text-elevate-black">Log in</LocalizedClientLink>{" "}
            for trade price
          </>
        ) : (
          "Log in for trade price"
        )}
      </span>
    </div>
  )
}
